import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ConfirmTokenLogin($authToken: String!, $loginDevice: String!) {
    confirmTokenLogin(authToken: $authToken, loginDevice: $loginDevice) {
      token
    }
  }
`;

export const confirmTokenLogin = (authToken, loginDevice) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: { authToken, loginDevice },
  }).then(({ data }) => getSingleProp(data));
